// extracted by mini-css-extract-plugin
export default {"component":"TLWT0"};